export var TemplateTypesEnum;
(function (TemplateTypesEnum) {
    TemplateTypesEnum["MINI_COURSE"] = "Mini-course";
    TemplateTypesEnum["GUIDE"] = "Guide";
    TemplateTypesEnum["TUTORIAL"] = "Tutorial";
    TemplateTypesEnum["CHALLENGE"] = "Challenge";
    TemplateTypesEnum["CUSTOM"] = "Custom";
})(TemplateTypesEnum || (TemplateTypesEnum = {}));
